import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import Headers from '../Header';
import NavigationBar from '../Navigation';
import Loader from '../../common/Loader';
import { PATH } from '../../../../utils/Constants';
import {
    onCustomReadMessage,
    onCustomSendMessage,
    onTyping,
    onReadMessage,
} from '../../../action/SocketActions';
import {
    getAllEducatorList,
    getChatMessageHistory,
    getEducatorChatList,
    getPreviousEducatorList,
    getStudentFileDownload,
    getStudentFileUpload,
    getUnreadPreviousUserList,
} from '../../../action/student/AppointmentAction';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import pdfImg from '../../../../utils/images/pdfpng.svg';
// import profileImg from "../../../../utils/images/profileImg.png";
import StaticImage from '../../../../utils/images/imagepng.svg';
import { showNotification } from '../../../action/NotificationAction';
import { clearChatMessages } from '../../../action/ChatAction';
import { customStyles, validateSearchNameInput } from '../../../../utils/Utility';
import Badge from '@mui/material/Badge';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class StudentMessageScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            selectedStudent: '',
            educatorList: [],
            isEducatorLoading: false,
            textMessage: '',
            chatImage: [],
            uploadedImages: [],
            receiverId: '',
            messages: [],
            previousEducatorList: [],
            educatorChatList: [],
            selectedOption: null,
            isSelected: false,
            searchValue: '',
            autoScrollToBottom: true,
            isAPICall: false,
            isScrollHeight: 0,
            isFile: false,
            isLoading: false,
            fileUrl: null,
            drafts: {},
            isEducatorSelected: false,
            activeTab: 'all',
            unreadEducatorList: [],
            typingIndicator: {},
            lastMessage: {},
            displayLastMessage: [],
            searchValueAll: '',
            searchValueNotRead: '',
            searchResultsEmpty: false,
            blmToken: '',
            userBfId: '',
        };
        this.fileInputRef = React.createRef();
        this.chatContainerRef = React.createRef();
    }

    //componentDidMount
    componentDidMount() {
        this.getPreviousEducatorList();
        this.getAllEducatorList();
        this.getUnreadPreviousUserList();
        this.fetchLatestMessages();
    }

    fetchLatestMessages = () => {
        const values = {
            pageNumber: 1,
            itemsPerPage: 100,
        };
        this.props.getChatMessageHistory(values, (response) => {
            if (response && response.status === 'success') {
                const messages = response.response.messages;
                const lastMessages = [];
                messages.forEach((msg) => {
                    const senderName = msg.me ? 'You:' : '';
                    const messageText = msg.fileId
                        ? msg.fileType === 'pdf'
                            ? 'File'
                            : 'Image'
                        : msg.message;
                    const messageObject = {
                        name: senderName,
                        message: messageText,
                        receiverId: msg.receiverUserId,
                        senderId: msg.senderUserId,
                        // userBfId: store.get("bloomIfAI_id"),
                    };
                    lastMessages.push(messageObject);
                });
                this.setState({ displayLastMessage: lastMessages });
            }
        });
    };

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        const selectedChat = JSON.parse(sessionStorage.getItem('selectedEducatorChat'));
        const isNewMessageArrived =
            prevProps.chatMessagesList.length < this.props.chatMessagesList.length;
        if (isNewMessageArrived && this.state.isEducatorSelected) {
            const { socketUnreadCount } = this.props;
            const lastMessage = this.props.chatMessagesList[this.props.chatMessagesList.length - 1];
            if (lastMessage?.senderUserId === selectedChat?.id) {
                const messageReadPayload = {
                    senderId: selectedChat?.id,
                    receiverId: lastMessage.receiverUserId,
                    message_read: true,
                };
                this.props.onReadMessage(messageReadPayload);
            }
            if (socketUnreadCount && this.state.previousEducatorList.length > 0) {
                const updatedEducatorList = this.state.previousEducatorList.map((educator) => {
                    if (educator.id === socketUnreadCount.senderUserId) {
                        const unreadCountForEducator = socketUnreadCount.unReadCountDetails.find(
                            (countDetail) => countDetail.id === educator.id
                        );

                        return {
                            ...educator,
                            unReadCount: unreadCountForEducator
                                ? unreadCountForEducator.unReadCount
                                : educator.unReadCount,
                            Message: lastMessage.message,
                        };
                    }
                    return educator;
                });
                this.setState({ previousEducatorList: updatedEducatorList });
            }
            if (this.state.isAPICall) {
                const chatContainer = this.chatContainerRef.current;
                chatContainer.scrollTop = chatContainer.scrollHeight - this.state.isScrollHeight;
            } else {
                this.scrollToBottom();
            }
            this.fetchLatestMessages();
        } else if (isNewMessageArrived && this.props.chatMessagesList.length > 0) {
            // Handle the case for a new account receiving the first message
            const lastMsg = this.props.chatMessagesList[this.props.chatMessagesList.length - 1];
            // If the sender is not the current user and not in previousEducatorList, add them
            if (lastMsg && lastMsg.senderUserId !== this.state.userBfId) {
                const alreadyInList = this.state.previousEducatorList.some(
                    (e) => e.id === lastMsg.senderUserId
                );
                if (!alreadyInList) {
                    // Try to find sender in educatorList for name, else fallback to id
                    const educator = this.state.educatorList.find(
                        (e) => e.id === lastMsg.senderUserId
                    ) || { id: lastMsg.senderUserId, name: lastMsg.senderName || 'Unknown' };
                    this.setState((prevState) => ({
                        previousEducatorList: [...prevState.previousEducatorList, educator],
                    }));
                }
            }
        } else {
            if (this.autoScrollToBottom) {
                this.scrollToBottom();
            }
        }
        if (prevProps.typingIndicator !== this.props.typingIndicator) {
            this.setState({ typingIndicator: this.props.typingIndicator });
        }
    }

    // scrollToBottom
    scrollToBottom = () => {
        const chatContainer = this.chatContainerRef.current;
        if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    };

    //handleScroll
    handleScroll = () => {
        const chatContainer = this.chatContainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatContainer;
        const enableScroll = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
        if (enableScroll) {
            this.autoScrollToBottom = true;
        } else {
            this.autoScrollToBottom = false;
        }
        if (scrollTop === 0) {
            if (this.props.chatLastPage > this.props.currentChatPage) {
                this.props.callChatAPI();
                this.setState({ isAPICall: true, isScrollHeight: scrollHeight });
            }
        } else {
            this.setState({ isAPICall: false });
        }
    };

    autoScrollToBottom = true;

    //handleFileUpload
    handleFileUpload = (event) => {
        const files = event.target.files;
        if (!files.length) {
            return;
        }
        const MAX_TOTAL_SIZE = 52428800; // 50MB
        const MAX_SINGLE_FILE_SIZE = 10485760; // 10MB

        let newChatImage = [...this.state.chatImage];
        let uploadedImages = [...this.state.uploadedImages];
        let totalUploadedSize = this.state.totalUploadedSize || 0;
        let newUploadSize = 0;
        const fileReaders = [];
        let isValid = true;
        const validFiles = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg' ||
                file.type === 'application/pdf'
            ) {
                if (file.size <= MAX_SINGLE_FILE_SIZE) {
                    newUploadSize += file.size;
                    if (totalUploadedSize + newUploadSize > MAX_TOTAL_SIZE) {
                        isValid = false;
                        this.setState({ isImageUploaded: false });
                        this.props.showNotification(
                            RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    validFiles.push(file);
                } else {
                    isValid = false;
                    this.setState({ isImageUploaded: false });
                    this.props.showNotification(
                        RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
            } else {
                isValid = false;
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                newChatImage.push(reader.result);
                uploadedImages.push(file);
                this.setState({
                    chatImage: [...newChatImage],
                    uploadedImages: [...uploadedImages],
                    totalUploadedSize: totalUploadedSize + newUploadSize,
                });
            };
            reader.readAsDataURL(file);
            fileReaders.push(reader);
        });

        if (isValid) {
            this.setState({ isImageUploaded: true });
        } else {
            this.setState({ isImageUploaded: false });
        }
    };

    //sendMessageClicked
    sendMessageClicked = () => {
        const { textMessage, uploadedImages, receiverId, educatorList } = this.state;
        const totalImageSize = uploadedImages.reduce((total, file) => total + file.size, 0);
        if (totalImageSize > 50 * 1024 * 1024) {
            this.props.showNotification(
                RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (textMessage.trim() === '' && uploadedImages.length === 0) {
            return;
        }
        const moveStudentToTop = () => {
            const student = educatorList.find((student) => student.id === receiverId);
            this.setState((prevState) => ({
                previousEducatorList: [
                    student,
                    ...prevState.previousEducatorList.filter((s) => s.id !== receiverId),
                ],
            }));
        };
        if (textMessage.trim() !== '') {
            const messagePayload = {
                textMessage: textMessage.trim(),
                fileId: null,
                havingImage: 0,
                receiverId,
                // userBfId: store.get("bloomIfAI_id"),
            };
            this.resetMessage();
            this.props.onCustomSendMessage(messagePayload, (message) => {
                this.setState((prevState) => ({
                    messages: [...prevState.messages, message],
                }));
                moveStudentToTop();
                this.fetchLatestMessages();
            });
        }
        if (uploadedImages.length > 0) {
            const formData = new FormData();
            uploadedImages.forEach((file) => {
                formData.append('multipartFiles', file);
            });
            formData.append('receiverUserId', receiverId);
            this.resetMessage();
            this.props.getStudentFileUpload(formData, (response) => {
                if (response.status === 'success') {
                    const uploadedImageUrl = response.response;
                    const messagePayload = {
                        textMessage: textMessage.trim() !== '' ? textMessage.trim() : undefined,
                        fileId: uploadedImageUrl,
                        havingImage: uploadedImageUrl ? 1 : 0,
                        receiverId,
                    };
                    this.setState((prevState) => ({
                        messages: [
                            ...prevState.messages,
                            {
                                ...messagePayload,
                                textMessage: textMessage.trim(),
                                fileId: uploadedImageUrl,
                                havingImage: uploadedImageUrl ? 1 : 0,
                            },
                        ],
                    }));
                    moveStudentToTop();
                    this.fetchLatestMessages();
                }
            });
        }
    };

    getUnreadPreviousUserList = (searchValue = '') => {
        const values = {
            search: searchValue,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getUnreadPreviousUserList(values, (result) => {
            if (result) {
                this.setState({
                    unreadEducatorList: result.response.data,
                    searchResultsEmpty: result.response.data.length === 0,
                });
            }
        });
    };

    //getPreviousEducatorList
    getPreviousEducatorList = (searchValue = '') => {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: searchValue,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getPreviousEducatorList(values, (result) => {
            this.setState({ isEducatorLoading: false });
            if (result) {
                this.setState({
                    previousEducatorList: result.response.data,
                    searchResultsEmpty: result.response.data.length === 0,
                });
            }
        });
    };

    //getAllEducatorList
    getAllEducatorList(id) {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getAllEducatorList(values, (result) => {
            this.setState({ isEducatorLoading: false });
            if (result) {
                this.setState({
                    educatorList: result.response.data,
                });
            }
        });
    }

    //getEducatorChatList
    getEducatorChatList(id) {
        this.setState({ isLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getEducatorChatList(id, values, (result) => {
            this.setState({ isLoading: false });
            if (result) {
                this.setState({
                    educatorChatList: result.response.messages,
                });
                this.scrollToBottom();
            }
        });
    }

    //handleChange
    handleChange = async (selectedOption) => {
        const searchValue = selectedOption?.value || '';
        const selectedStudent = this.state.educatorList.find(
            (educator) => educator.id === searchValue
        );
        const isStudentInList =
            selectedStudent &&
            this.state.previousEducatorList.some((educator) => educator.id === selectedStudent.id);
        const newState = {
            selectedStudent: selectedStudent ? selectedStudent.name : '',
            receiverId: selectedStudent ? selectedStudent.id : '',
            isSelected: !!selectedStudent,
            searchValue: '',
            isFile: false,
        };
        // Add selected educator to previousEducatorList if not present
        if (this.state.receiverId) {
            const currentDraft = {
                textMessage: this.state.textMessage,
            };
            if (currentDraft.textMessage.trim() !== '') {
                sessionStorage.setItem(
                    `draft_${this.state.receiverId}`,
                    JSON.stringify(currentDraft)
                );
            } else {
                sessionStorage.removeItem(`draft_${this.state.receiverId}`);
            }
        }
        if (selectedStudent && !isStudentInList) {
            newState.previousEducatorList = [...this.state.previousEducatorList, selectedStudent];
        }
        this.setState(newState, async () => {
            if (selectedStudent) {
                this.clearAllFiles();
                this.getEducatorChatList(selectedStudent.id);
                const savedDraft = sessionStorage.getItem(`draft_${selectedStudent.id}`);
                if (savedDraft) {
                    const { textMessage } = JSON.parse(savedDraft);
                    this.setState({
                        textMessage: textMessage || '',
                    });
                }
            }
        });
    };

    //selectEducator
    selectEducator = async (educator) => {
        sessionStorage.setItem('selectedEducatorChat', JSON.stringify(educator));
        this.props.clearChatMessages();
        if (this.state.receiverId) {
            const currentDraft = {
                textMessage: this.state.textMessage,
            };
            if (currentDraft.textMessage.trim() !== '') {
                sessionStorage.setItem(
                    `draft_${this.state.receiverId}`,
                    JSON.stringify(currentDraft)
                );
            } else {
                sessionStorage.removeItem(`draft_${this.state.receiverId}`);
            }
        }
        const isStudentInList = this.state.previousEducatorList.some((s) => s.id === educator.id);
        this.setState(
            (prevState) => ({
                previousEducatorList: !isStudentInList
                    ? [...prevState.previousEducatorList, educator]
                    : prevState.previousEducatorList,
                selectedStudent: educator.name,
                receiverId: educator.id,
                textMessage: '',
                searchValue: '',
                isFile: false,
                isEducatorSelected: true,
            }),
            async () => {
                this.clearAllFiles();
                this.getEducatorChatList(educator.id);
                const savedDraft = sessionStorage.getItem(`draft_${educator.id}`);
                if (savedDraft) {
                    const { textMessage } = JSON.parse(savedDraft);
                    this.setState({
                        textMessage: textMessage || '',
                    });
                }
            }
        );
    };

    //handleFileDownload
    handleFileDownload = (fileId) => {
        this.props.getStudentFileDownload(fileId, null, (response) => {
            if (response && response.code === 200) {
                window.open(response.response, '_blank');
            } else {
                this.props.showNotification(response.message, 'error');
            }
        });
    };

    //handleFileButtonClick
    handleFileButtonClick = () => {
        this.setState((prevState) => ({
            isFile: !prevState.isFile,
        }));
    };

    //handleSearchUser
    handleSearchUser = (e) => {
        const searchValue = e.target.value;
        if (validateSearchNameInput(searchValue) || searchValue === '') {
            this.setState({ searchValue }, () => {
                if (this.state.activeTab === 'all') {
                    this.setState({ searchValueAll: searchValue }, () => {
                        this.getPreviousEducatorList(searchValue);
                    });
                } else if (this.state.activeTab === 'not-read') {
                    this.setState({ searchValueNotRead: searchValue }, () => {
                        this.getUnreadPreviousUserList(searchValue);
                    });
                }
            });
        }
    };

    //handleMenuOpen
    handleMenuOpen = () => {
        this.setState({ searchValue: '' }, () => {
            this.getPreviousEducatorList();
        });
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    getInitials(name) {
        if (!name) return '';
        const nameParts = name.trim().split(' ');
        const first = nameParts[0]?.charAt(0).toUpperCase() || '';
        const second = nameParts[1]?.charAt(0).toUpperCase() || '';
        return first + second;
    }

    handleSelectInputChange = (inputValue, { action }) => {
        const allowedCharacters = /^[a-zA-Z0-9\s]*$/;
        if (action === 'input-change') {
            if (allowedCharacters.test(inputValue)) {
                return inputValue;
            } else {
                return '';
            }
        }
        return inputValue;
    };

    // handleInputChange
    handleInputChange = (e) => {
        const message = e.target.value;
        this.setState({ textMessage: message });
        if (message.trim() !== '' && !this.state.isTyping) {
            this.setState({ isTyping: true });
            const typingPayload = {
                senderId: this.props.userId,
                receiverId: this.state.receiverId,
                typing: 'true',
            };
            this.props.onTyping(typingPayload);
        }
        if (message.trim() === '' && this.state.isTyping) {
            this.setState({ isTyping: false });
            const typingPayload = {
                senderId: this.props.userId,
                receiverId: this.state.receiverId,
                typing: 'false',
            };

            this.props.onTyping(typingPayload);
        }
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
            if (this.state.isTyping) {
                this.setState({ isTyping: false });
                const typingPayload = {
                    senderId: this.props.userId,
                    receiverId: this.state.receiverId,
                    typing: 'false',
                };
                this.props.onTyping(typingPayload);
            }
        }, 5000);
    };

    //handleBackspaceClick
    handleBackspaceClick = () => {
        this.setState({ selectedStudent: null });
    };

    //resetMessage
    resetMessage = () => {
        this.setState(
            {
                textMessage: '',
                uploadedImages: [],
                chatImage: [],
                totalUploadedSize: 0,
                isImageUploaded: false,
            },
            () => {
                this.fileInputRef.current.value = '';
            }
        );
    };

    //clearAllFiles
    clearAllFiles = () => {
        this.setState(
            {
                textMessage: '',
                chatImage: [],
                uploadedImages: [],
            },
            () => {
                this.fileInputRef.current.value = '';
                if (this.state.receiverId) {
                    sessionStorage.removeItem(`draft_${this.state.receiverId}`);
                }
            }
        );
    };

    //removeFile
    removeFile = (index) => {
        this.setState(
            (prevState) => {
                const updatedChatImage = [...prevState.chatImage];
                const updatedUploadedImages = [...prevState.uploadedImages];
                updatedChatImage.splice(index, 1);
                updatedUploadedImages.splice(index, 1);
                return {
                    chatImage: updatedChatImage,
                    uploadedImages: updatedUploadedImages,
                };
            },
            () => {
                this.fileInputRef.current.value = '';
            }
        );
    };

    //customOptionLabel
    customOptionLabel = ({ label }) => (
        <div className="overflow-hidden truncate" title={label}>
            {label}
        </div>
    );

    formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        return `${hours}:${minutes} ${ampm}`;
    }

    render() {
        const { chatMessagesList, socketUnreadCount } = this.props;
        const {
            receiverId,
            educatorList,
            chatImage,
            activeTab,
            unreadEducatorList,
            // searchResultsEmpty,
            searchValueAll,
            searchValueNotRead,
        } = this.state;

        let options = educatorList.map((educator) => ({
            value: educator.id,
            label: educator.name,
        }));
        const filteredMessagesFromList = chatMessagesList.filter(
            (message) =>
                (message.senderUserId === receiverId || message.receiverUserId === receiverId) &&
                ((message.message && message.message.trim() !== '') || message.fileId)
        );
        const combinedMessages = [...this.state.educatorChatList, ...filteredMessagesFromList];
        const uniqueMessages = combinedMessages.reduce((acc, message) => {
            if (!acc.some((msg) => msg.messageId === message.messageId)) {
                acc.push(message);
            }
            return acc;
        }, []);
        const sortedMessages = uniqueMessages.sort((a, b) => {
            return new Date(a.createdTime) - new Date(b.createdTime);
        });
        const selectedEducator = educatorList.find(
            (educator) => educator.id === this.state.receiverId
        );

        return (
            <>
                <div className="fixed top-0 left-0 flex w-full h-full">
                    <div
                        className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${this.state.mobileNav ? 'block' : 'hidden'}`}
                    ></div>
                    <NavigationBar
                        nav={true}
                        {...this.props}
                        active={PATH.IM_PATIENT.MESSAGES}
                        mobileNav={this.state.mobileNav}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <main className="flex flex-col flex-grow h-screen overflow-hidden">
                        <Headers
                            {...this.props}
                            title="Message"
                            onClickMobileNav={this.onClickMobileNav}
                        />
                        <div className="w-full contents">
                            <div className="flex justify-end w-full px-3 py-2 bg-UIBackground">
                                <Select
                                    onChange={this.handleChange}
                                    onMenuOpen={this.handleMenuOpen}
                                    name="form-field-name"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={options}
                                    placeholder={this.props.t('selectOrEnterName')}
                                    noOptionsMessage={() => this.props.t('noRecordFound')}
                                    className="w-1/3"
                                    styles={customStyles}
                                    value={this.state.selectedOption}
                                    formatOptionLabel={this.customOptionLabel}
                                    onInputChange={this.handleSelectInputChange}
                                />
                            </div>
                            <div className="flex flex-row w-full h-full overflow-hidden bg-UIBackground">
                                <div
                                    className={`bg-card w-[100%] md:w-[30%] m-5 rounded-lg ${this.state.selectedStudent ? 'sm:block hidden' : 'block'}`}
                                >
                                    <header className="px-5">
                                        <div className="py-3">
                                            <div className="relative mt-2">
                                                <input
                                                    type="text"
                                                    onChange={this.handleSearchUser}
                                                    value={
                                                        activeTab === 'all'
                                                            ? searchValueAll
                                                            : searchValueNotRead
                                                    }
                                                    className="w-full py-1.5 px-4 bg-schedule rounded-lg text-white"
                                                    placeholder={this.props.t('search')}
                                                    autoComplete="off"
                                                    maxLength={50}
                                                />
                                                <i className="fas fa-search absolute right-3 top-1/2 transform -translate-y-1/2 text-[#10DACE]"></i>
                                            </div>
                                        </div>
                                    </header>
                                    <div className="w-full px-4">
                                        <div className="flex w-full h-[42px] p-1 gap-1 rounded-lg bg-[#181B22]">
                                            <button
                                                className={`flex-1 flex items-center justify-center py-2 rounded-lg text-white transition-all duration-150 ${
                                                    this.state.activeTab === 'all'
                                                        ? 'bg-[#543CC2]'
                                                        : 'text-gray-400'
                                                }`}
                                                onClick={() => {
                                                    this.setState({
                                                        activeTab: 'all',
                                                        searchValueAll: '',
                                                    });
                                                    this.getPreviousEducatorList();
                                                }}
                                            >
                                                {this.props.t('all')}
                                            </button>
                                            <button
                                                className={`flex-1 flex items-center justify-center py-2 rounded-lg transition-all duration-150 ${
                                                    this.state.activeTab === 'not-read'
                                                        ? 'bg-[#543CC2] text-white'
                                                        : 'text-gray-400'
                                                }`}
                                                onClick={() => {
                                                    this.setState({
                                                        activeTab: 'not-read',
                                                        searchValueNotRead: '',
                                                    });
                                                    this.getUnreadPreviousUserList();
                                                }}
                                            >
                                                {this.props.t('notRead')}
                                            </button>
                                        </div>
                                    </div>
                                    {activeTab === 'not-read' && unreadEducatorList.length === 0 ? (
                                        <div className="flex items-center justify-center text-white mt-[35%]">
                                            {this.props.t('noUnreadChatsFound')}
                                        </div>
                                    ) : (
                                        <div className="overflow-y-auto h-[50vh] lg:h-[49vh] xl:h-[49vh] 2xl:h-[59vh]">
                                            {activeTab === 'all' &&
                                                (this.state.previousEducatorList.length === 0 ? (
                                                    <div className="flex items-center justify-center text-white mt-[35%]">
                                                        {this.props.t('noUsersFound')}
                                                    </div>
                                                ) : (
                                                    this.state.previousEducatorList.map(
                                                        (educator, index) => {
                                                            const savedDraft =
                                                                sessionStorage.getItem(
                                                                    `draft_${educator.id}`
                                                                );
                                                            let draftExists = false;
                                                            if (savedDraft) {
                                                                const parsedDraft =
                                                                    JSON.parse(savedDraft);
                                                                draftExists =
                                                                    parsedDraft.textMessage &&
                                                                    parsedDraft.textMessage.trim() !==
                                                                        '';
                                                            }
                                                            return (
                                                                <div
                                                                    key={educator.id || index}
                                                                    className={`relative flex items-center my-5 gap-x-4 px-5 cursor-pointer py-2 ${
                                                                        educator.id === receiverId
                                                                            ? 'bg-[#34373E]'
                                                                            : 'hover:bg-[#34373E]'
                                                                    }`}
                                                                    onClick={() =>
                                                                        this.selectEducator(
                                                                            educator
                                                                        )
                                                                    }
                                                                >
                                                                    {/* {educator.profileImage ? (
                                    <img
                                      className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                      src={educator.profileImage}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                      src={profileImg}
                                      alt=""
                                    />
                                  )} */}
                                                                    <div className="w-[50px] h-[50px] rounded-full bg-black flex items-center justify-center text-white text-md font-medium">
                                                                        {this.getInitials(
                                                                            educator.name
                                                                        )}
                                                                    </div>
                                                                    <div className="flex items-center flex-grow">
                                                                        <div className="flex flex-col">
                                                                            <h2
                                                                                className="text-base font-medium lg:text-lg md:text-white whitespace-nowrap"
                                                                                title={
                                                                                    educator.name
                                                                                }
                                                                            >
                                                                                {educator.name
                                                                                    .length > 10
                                                                                    ? educator.name.slice(
                                                                                          0,
                                                                                          10
                                                                                      ) + '...'
                                                                                    : educator.name}
                                                                            </h2>
                                                                            <small
                                                                                className={`text-sm md:text-base w-50 whitespace-nowrap ${
                                                                                    educator.unReadCount >
                                                                                    0
                                                                                        ? 'text-white'
                                                                                        : 'text-[#B9B9B9]'
                                                                                }`}
                                                                            >
                                                                                {this.props
                                                                                    .typingIndicatorShown
                                                                                    ?.typingIndicator &&
                                                                                (this.props
                                                                                    .typingIndicatorShown
                                                                                    .receiverUserId ===
                                                                                    educator.id ||
                                                                                    this.props
                                                                                        .typingIndicatorShown
                                                                                        .senderUserId ===
                                                                                        educator.id) ? (
                                                                                    <span className="text-green-500">
                                                                                        {
                                                                                            educator.name
                                                                                        }{' '}
                                                                                        {this.props.t(
                                                                                            'typing'
                                                                                        )}
                                                                                    </span>
                                                                                ) : draftExists ? (
                                                                                    <span className="text-green-500">
                                                                                        {this.props.t(
                                                                                            'draft'
                                                                                        )}
                                                                                    </span>
                                                                                ) : (
                                                                                    this.state.displayLastMessage
                                                                                        .filter(
                                                                                            (fil) =>
                                                                                                fil.receiverId ===
                                                                                                    educator.id ||
                                                                                                fil.senderId ===
                                                                                                    educator.id
                                                                                        )
                                                                                        .map(
                                                                                            (
                                                                                                item,
                                                                                                messageIndex
                                                                                            ) => (
                                                                                                <p
                                                                                                    key={
                                                                                                        messageIndex
                                                                                                    }
                                                                                                    className="flex max-w-full gap-1"
                                                                                                >
                                                                                                    <span className="font-medium">
                                                                                                        {
                                                                                                            item.name
                                                                                                        }
                                                                                                    </span>
                                                                                                    <span
                                                                                                        className="truncate overflow-hidden whitespace-nowrap max-w-[150px]"
                                                                                                        title={
                                                                                                            item.message
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            item.message
                                                                                                        }
                                                                                                    </span>
                                                                                                </p>
                                                                                            )
                                                                                        )
                                                                                )}
                                                                            </small>
                                                                            {/* <h2 className="text-sm md:text-white w-50 whitespace-nowrap">
                                        {draftExists && (
                                          <span className="ml-5 text-green-500">
                                            Draft
                                          </span>
                                        )}
                                      </h2> */}
                                                                        </div>
                                                                        <div className="absolute flex flex-col items-end -translate-y-2/3 right-4 top-1/2 gap-y-2">
                                                                            <small className="text-sm text-white md:text-sm w-max whitespace-nowrap">
                                                                                {
                                                                                    educator.previousMessage
                                                                                }
                                                                            </small>
                                                                            <Badge
                                                                                className="mt-2 text-white"
                                                                                badgeContent={(() => {
                                                                                    if (
                                                                                        educator.id ===
                                                                                        this.state
                                                                                            .receiverId
                                                                                    ) {
                                                                                        return null;
                                                                                    }
                                                                                    if (
                                                                                        socketUnreadCount?.senderUserId
                                                                                    ) {
                                                                                        const foundUnreadCount =
                                                                                            socketUnreadCount?.unReadCountDetails?.find(
                                                                                                (
                                                                                                    countDetail
                                                                                                ) =>
                                                                                                    countDetail.id ===
                                                                                                    educator.id
                                                                                            );
                                                                                        return foundUnreadCount?.unReadCount;
                                                                                    }
                                                                                    return educator.unReadCount;
                                                                                })()}
                                                                                sx={{
                                                                                    '& .MuiBadge-badge':
                                                                                        {
                                                                                            backgroundColor:
                                                                                                '#10DACE',
                                                                                            color: 'black',
                                                                                        },
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )
                                                ))}
                                            {activeTab === 'not-read' &&
                                                unreadEducatorList.map((educator, index) => {
                                                    const savedDraft = sessionStorage.getItem(
                                                        `draft_${educator.id}`
                                                    );
                                                    let draftExists = false;
                                                    if (savedDraft) {
                                                        const parsedDraft = JSON.parse(savedDraft);
                                                        draftExists =
                                                            parsedDraft.textMessage &&
                                                            parsedDraft.textMessage.trim() !== '';
                                                    }
                                                    return (
                                                        <div
                                                            key={educator.id || index}
                                                            className={`relative flex items-center my-5 gap-x-4 px-5 cursor-pointer py-2 ${
                                                                educator.id === receiverId
                                                                    ? 'bg-[#34373E]'
                                                                    : 'hover:bg-[#34373E]'
                                                            }`}
                                                            onClick={() =>
                                                                this.selectEducator(educator)
                                                            }
                                                        >
                                                            {/* {educator.profileImage ? (
                                <img
                                  className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                  src={educator.profileImage}
                                  alt=""
                                />
                              ) : (
                                <img
                                  className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                  src={profileImg}
                                  alt=""
                                />
                              )} */}
                                                            <div className="w-[50px] h-[50px] rounded-full bg-black flex items-center justify-center text-white text-md font-medium">
                                                                {this.getInitials(educator.name)}
                                                            </div>
                                                            <div className="flex items-center flex-grow">
                                                                <div className="flex flex-col">
                                                                    <h2
                                                                        className="text-base font-medium lg:text-lg md:text-white whitespace-nowrap"
                                                                        title={educator.name}
                                                                    >
                                                                        {educator.name.length > 10
                                                                            ? educator.name.slice(
                                                                                  0,
                                                                                  10
                                                                              ) + '...'
                                                                            : educator.name}
                                                                    </h2>
                                                                    <small
                                                                        className={`text-sm md:text-base w-50 whitespace-nowrap ${
                                                                            educator.unReadCount > 0
                                                                                ? 'text-white'
                                                                                : 'text-[#B9B9B9]'
                                                                        }`}
                                                                    >
                                                                        {this.props
                                                                            .typingIndicatorShown
                                                                            ?.typingIndicator &&
                                                                        (this.props
                                                                            .typingIndicatorShown
                                                                            .receiverUserId ===
                                                                            educator.id ||
                                                                            this.props
                                                                                .typingIndicatorShown
                                                                                .senderUserId ===
                                                                                educator.id) ? (
                                                                            <span className="text-green-500">
                                                                                {educator.name}{' '}
                                                                                {this.props.t(
                                                                                    'typing'
                                                                                )}
                                                                            </span>
                                                                        ) : draftExists ? (
                                                                            <span className="text-green-500">
                                                                                {this.props.t(
                                                                                    'draft'
                                                                                )}
                                                                            </span>
                                                                        ) : (
                                                                            this.state.displayLastMessage
                                                                                .filter(
                                                                                    (fil) =>
                                                                                        fil.receiverId ===
                                                                                            educator.id ||
                                                                                        fil.senderId ===
                                                                                            educator.id
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        item,
                                                                                        messageIndex
                                                                                    ) => (
                                                                                        <p
                                                                                            key={
                                                                                                messageIndex
                                                                                            }
                                                                                            className="flex max-w-full gap-1"
                                                                                        >
                                                                                            <span className="font-medium">
                                                                                                {
                                                                                                    item.name
                                                                                                }
                                                                                            </span>
                                                                                            <span
                                                                                                className="truncate overflow-hidden whitespace-nowrap max-w-[150px]"
                                                                                                title={
                                                                                                    item.message
                                                                                                }
                                                                                            >
                                                                                                {
                                                                                                    item.message
                                                                                                }
                                                                                            </span>
                                                                                        </p>
                                                                                    )
                                                                                )
                                                                        )}
                                                                    </small>
                                                                    {/* {draftExists && (
                                    <h2 className="ml-5 text-sm text-green-500 md:text-base w-50 whitespace-nowrap">
                                      Draft
                                    </h2>
                                  )} */}
                                                                </div>
                                                                <div className="absolute flex flex-col items-end -translate-y-2/3 right-4 top-1/2 gap-y-2">
                                                                    <small className="text-sm text-white md:text-sm w-max whitespace-nowrap">
                                                                        {educator.previousMessage}
                                                                    </small>
                                                                    <Badge
                                                                        className="mt-2 text-white"
                                                                        badgeContent={(() => {
                                                                            if (
                                                                                educator.id ===
                                                                                this.state
                                                                                    .receiverId
                                                                            ) {
                                                                                return null;
                                                                            }
                                                                            if (
                                                                                socketUnreadCount?.senderUserId
                                                                            ) {
                                                                                const foundUnreadCount =
                                                                                    socketUnreadCount?.unReadCountDetails?.find(
                                                                                        (
                                                                                            countDetail
                                                                                        ) =>
                                                                                            countDetail.id ===
                                                                                            educator.id
                                                                                    );
                                                                                return foundUnreadCount?.unReadCount;
                                                                            }
                                                                            return educator.unReadCount;
                                                                        })()}
                                                                        sx={{
                                                                            '& .MuiBadge-badge': {
                                                                                backgroundColor:
                                                                                    '#10DACE',
                                                                                color: 'black',
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}
                                </div>
                                <>
                                    {this.state.selectedStudent ? (
                                        <div className="w-[100%] md:w-[70%] flex flex-col bg-card rounded-lg my-5 mx-3">
                                            <header className="flex items-center justify-between p-4">
                                                <div className="flex items-center">
                                                    <button
                                                        className="p-2 mr-2 rounded-full sm:hidden"
                                                        onClick={this.handleBackspaceClick}
                                                        aria-label="Back to Previous Student"
                                                    >
                                                        <i className="fas fa-arrow-left"></i>
                                                    </button>
                                                    <div className="flex items-center">
                                                        {/* {selectedEducator?.profileImage ? (
                              <img
                                className="w-10 h-10 mr-2 rounded-full"
                                src={selectedEducator.profileImage}
                                alt="Profile"
                              />
                            ) : (
                              <img
                                className="w-10 h-10 mr-2 rounded-full"
                                src={profileImg}
                                alt="Profile"
                              />
                            )} */}
                                                        <div className="w-[40px] h-[40px] rounded-full bg-black flex items-center justify-center text-white text-sm">
                                                            {this.getInitials(
                                                                selectedEducator.name
                                                            )}
                                                        </div>
                                                        &nbsp;
                                                        <h1
                                                            className="font-semibold text-white lg:text-2xl md:text-base"
                                                            title={this.state.selectedStudent}
                                                        >
                                                            {this.state.selectedStudent ||
                                                                'Team Member Name'}
                                                        </h1>
                                                    </div>
                                                </div>
                                                <div
                                                    className="flex items-center pr-5 text-white cursor-pointer"
                                                    onClick={this.handleFileButtonClick}
                                                >
                                                    <svg
                                                        width="25"
                                                        height="26"
                                                        viewBox="0 0 25 26"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12.8438 13.1564L10.2708 15.7293C8.84376 17.1564 8.84376 19.4584 10.2708 20.8855C11.6979 22.3126 14 22.3126 15.4271 20.8855L19.4792 16.8334C22.323 13.9897 22.323 9.36468 19.4792 6.52092C16.6354 3.67717 12.0104 3.67717 9.16668 6.52092L4.75 10.9376C2.3125 13.3751 2.3125 17.3334 4.75 19.7814"
                                                            stroke="white"
                                                            strokeWidth="1.5625"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    {this.state.isFile ? this.props.t('chat') : ''}
                                                </div>
                                            </header>
                                            {this.state.isLoading ? (
                                                <Loader />
                                            ) : (
                                                <div
                                                    className="flex flex-col flex-1 p-4 overflow-y-auto bg-collaboratortable"
                                                    onScroll={() => this.handleScroll()}
                                                    ref={this.chatContainerRef}
                                                >
                                                    <div className="mt-auto">
                                                        {sortedMessages
                                                            .filter(
                                                                (message) =>
                                                                    !this.state.isFile ||
                                                                    message.fileId
                                                            )
                                                            .map((message, index) => {
                                                                const senderName =
                                                                    message.senderUserId ===
                                                                    this.state.receiverId
                                                                        ? selectedEducator?.name ||
                                                                          this.props.t('owner')
                                                                        : this.props.t('you');
                                                                const time = this.formatTimestamp(
                                                                    message.createdTime
                                                                );
                                                                let status = null;

                                                                if (
                                                                    message.senderUserId !==
                                                                    this.state.receiverId
                                                                ) {
                                                                    const tickColor =
                                                                        this.props.OnMessageRead ===
                                                                        true
                                                                            ? '#10DACE'
                                                                            : message.delivered
                                                                              ? '#B9B9B9'
                                                                              : '#10DACE';

                                                                    status = (
                                                                        <svg
                                                                            width="18"
                                                                            height="12"
                                                                            viewBox="0 0 18 12"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M1 6.9L4.143 10.5L12 1.5M17 1.563L8.428 10.563L8 10"
                                                                                stroke={tickColor}
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </svg>
                                                                    );
                                                                }

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className={`flex mb-4 ${message.senderUserId === receiverId ? '' : 'justify-end'}`}
                                                                    >
                                                                        {/* {message.senderUserId === receiverId && (
                                      <img
                                        className="w-10 h-10 mr-2 rounded-full"
                                        src={
                                          selectedEducator?.profileImage
                                            ? selectedEducator.profileImage
                                            : profileImg
                                        }
                                        alt="Profile"
                                      />
                                    )} */}
                                                                        {message.senderUserId ===
                                                                            receiverId && (
                                                                            <div className="w-[30px] h-[30px] rounded-full bg-black flex items-center justify-center text-white text-sm">
                                                                                {this.getInitials(
                                                                                    selectedEducator.name
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        &nbsp;
                                                                        <div className="flex flex-col">
                                                                            <div className="flex items-center mb-1">
                                                                                <span className="flex items-center text-sm text-white">
                                                                                    {senderName}{' '}
                                                                                    &nbsp;
                                                                                    <svg
                                                                                        width="4"
                                                                                        height="4"
                                                                                        viewBox="0 0 4 4"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <circle
                                                                                            cx="2"
                                                                                            cy="2"
                                                                                            r="2"
                                                                                            fill="#B9B9B9"
                                                                                        />
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="flex items-center ml-2">
                                                                                    <span className="mr-1 text-xs text-gray-500">
                                                                                        {time}
                                                                                    </span>
                                                                                    {status}
                                                                                </div>
                                                                            </div>
                                                                            {message.message && (
                                                                                <div
                                                                                    className={`${
                                                                                        message.senderUserId ===
                                                                                        receiverId
                                                                                            ? 'bg-black text-white'
                                                                                            : 'bg-[#34373E] text-white'
                                                                                    } rounded-md p-2`}
                                                                                    style={{
                                                                                        maxWidth:
                                                                                            '50ch',
                                                                                        wordWrap:
                                                                                            'break-word',
                                                                                    }}
                                                                                >
                                                                                    <p className="text-sm">
                                                                                        {message.message
                                                                                            .split(
                                                                                                /\n/
                                                                                            )
                                                                                            .map(
                                                                                                (
                                                                                                    message
                                                                                                ) => (
                                                                                                    <React.Fragment
                                                                                                        key={
                                                                                                            message
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            message
                                                                                                        }
                                                                                                        <br />
                                                                                                    </React.Fragment>
                                                                                                )
                                                                                            )}
                                                                                    </p>
                                                                                </div>
                                                                            )}
                                                                            {message.fileId && (
                                                                                <a
                                                                                    href={
                                                                                        this.state
                                                                                            .fileUrl
                                                                                    }
                                                                                    onClick={(
                                                                                        e
                                                                                    ) => {
                                                                                        this.handleFileDownload(
                                                                                            message.fileId
                                                                                        );
                                                                                    }}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <img
                                                                                        src={
                                                                                            message.fileType ===
                                                                                            'pdf'
                                                                                                ? pdfImg
                                                                                                : StaticImage
                                                                                        }
                                                                                        alt="Uploaded"
                                                                                        onError={(
                                                                                            e
                                                                                        ) => {
                                                                                            if (
                                                                                                message.fileType !==
                                                                                                'pdf'
                                                                                            ) {
                                                                                                e.target.src =
                                                                                                    pdfImg;
                                                                                            }
                                                                                        }}
                                                                                        className="object-cover w-20 h-20 mt-2 cursor-pointer"
                                                                                    />
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        {this.props.typingIndicatorShown
                                                            ?.typingIndicator &&
                                                            (this.state.receiverId ===
                                                                this.props.typingIndicatorShown
                                                                    .receiverUserId ||
                                                                this.state.receiverId ===
                                                                    this.props.typingIndicatorShown
                                                                        .senderUserId) && (
                                                                <div className="flex justify-start mb-4">
                                                                    <div className="flex items-center space-x-1">
                                                                        <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:0ms]"></div>
                                                                        <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:200ms]"></div>
                                                                        <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:400ms]"></div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="w-full rounded-lg bg-collaboratortable">
                                                <div
                                                    className="p-4 overflow-x-auto"
                                                    style={{ maxHeight: '400px' }}
                                                >
                                                    <div className="flex space-x-4">
                                                        {chatImage.length > 0 &&
                                                            chatImage.map((image, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="relative flex-shrink-0 border border-[#34373E]"
                                                                >
                                                                    {image.includes(
                                                                        'data:application/pdf'
                                                                    ) ? (
                                                                        <div>
                                                                            <i
                                                                                className="fa-solid fa-file-pdf"
                                                                                style={{
                                                                                    color: '#c30909',
                                                                                    width: '5rem',
                                                                                    height: '5rem',
                                                                                    borderRadius:
                                                                                        '0.5rem',
                                                                                    fontSize:
                                                                                        '50px',
                                                                                    display: 'flex',
                                                                                    justifyContent:
                                                                                        'center',
                                                                                    alignItems:
                                                                                        'center',
                                                                                }}
                                                                            ></i>
                                                                        </div>
                                                                    ) : (
                                                                        <img
                                                                            src={image}
                                                                            className="w-20 h-20 rounded"
                                                                            key={index}
                                                                            alt=""
                                                                        />
                                                                    )}
                                                                    <span
                                                                        className="cursor-pointer fas fa-times-circle text-red"
                                                                        style={{
                                                                            position: 'relative',
                                                                            left: '75px',
                                                                            bottom: '90px',
                                                                        }}
                                                                        onClick={() => {
                                                                            this.removeFile(
                                                                                index,
                                                                                'image'
                                                                            );
                                                                        }}
                                                                    ></span>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                                <div className="relative flex items-center px-3 m-2 rounded-full bg-dateselect">
                                                    <div className="relative flex items-center flex-grow">
                                                        <textarea
                                                            className="w-full p-3 text-justify text-white bg-transparent rounded-full resize-none focus:outline-none"
                                                            placeholder={this.props.t(
                                                                'writeAMessage'
                                                            )}
                                                            value={this.state.textMessage}
                                                            onChange={this.handleInputChange}
                                                            onKeyPress={(e) => {
                                                                if (
                                                                    e.key === 'Enter' &&
                                                                    !e.shiftKey
                                                                ) {
                                                                    e.preventDefault();
                                                                    this.sendMessageClicked();
                                                                }
                                                            }}
                                                            maxLength={255}
                                                            rows={1}
                                                        />
                                                    </div>
                                                    <div className="flex space-x-2">
                                                        <button
                                                            className="p-2 text-white rounded-full bg-collaboratortable"
                                                            onClick={() =>
                                                                this.fileInputRef.current.click()
                                                            }
                                                        >
                                                            <svg
                                                                width="19"
                                                                height="18"
                                                                viewBox="0 0 19 18"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M10.1534 9.1118L8.3123 10.9529C7.29114 11.974 7.29114 13.6213 8.3123 14.6424C9.33346 15.6636 10.9807 15.6636 12.0019 14.6424L14.9014 11.743C16.9362 9.7081 16.9362 6.39865 14.9014 4.36379C12.8665 2.32893 9.55707 2.32893 7.52221 4.36379L4.36184 7.52416C2.61767 9.26833 2.61767 12.1007 4.36184 13.8524"
                                                                    stroke="white"
                                                                    strokeWidth="1.11806"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </button>
                                                        <button
                                                            className="p-2 text-white rounded-full bg-[#755FDC]"
                                                            onClick={this.sendMessageClicked}
                                                        >
                                                            <svg
                                                                width="19"
                                                                height="18"
                                                                viewBox="0 0 19 18"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.66373 4.76624L11.9919 2.65684C14.8318 1.71022 16.3747 3.26059 15.4355 6.10045L13.3261 12.4286C11.9099 16.6847 9.58438 16.6847 8.16817 12.4286L7.54206 10.5503L5.66373 9.9242C1.40766 8.508 1.40766 6.1899 5.66373 4.76624Z"
                                                                    stroke="white"
                                                                    strokeWidth="1.11806"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M7.68457 10.2298L10.353 7.55396"
                                                                    stroke="white"
                                                                    strokeWidth="1.11806"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <input
                                                        type="file"
                                                        ref={this.fileInputRef}
                                                        className="hidden"
                                                        accept=".png, .jpeg, .jpg, .pdf"
                                                        onChange={this.handleFileUpload}
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="w-[100%] md:w-[70%] sm:block hidden md:flex flex-col flex-1 items-center justify-center bg-card text-white rounded-lg my-5 mx-3">
                                            {this.props.t('selectOwnerToStart')}
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </main>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        chatMessagesList: state.ChatReducerList.chatMessagesList,
        socketUnreadCount: {
            unReadCountDetails: state.UnreadReducerCount.unReadCountDetails,
            unReadMessageCount: state.UnreadReducerCount.unReadMessageCount,
            receiverUserId: state.UnreadReducerCount.receiverUserId,
            senderUserId: state.UnreadReducerCount.senderUserId,
            receiverUnReadMessageCount: state.UnreadReducerCount.receiverUnReadMessageCount,
        },
        typingIndicatorShown: {
            typingIndicator: state.ChatReducerList.typingIndicator,
            receiverUserId: state.ChatReducerList.receiverUserId,
            senderUserId: state.ChatReducerList.senderUserId,
        },
        OnMessageRead: state.ChatReducerList.message_read,
    };
};

const mapDispatchtoProps = (dispatch) => {
    return {
        onCustomSendMessage: (input, callback) => {
            dispatch(onCustomSendMessage(input, callback));
        },
        onCustomReadMessage: (input) => {
            dispatch(onCustomReadMessage(input));
        },
        onReadMessage: (input) => {
            dispatch(onReadMessage(input));
        },
        getAllEducatorList: (id, values, callback) => {
            dispatch(getAllEducatorList(id, values, callback));
        },
        getPreviousEducatorList: (values, callback) => {
            dispatch(getPreviousEducatorList(values, callback));
        },
        getEducatorChatList: (id, values, callback) => {
            dispatch(getEducatorChatList(id, values, callback));
        },
        getStudentFileUpload: (values, callback) => {
            dispatch(getStudentFileUpload(values, callback));
        },
        getStudentFileDownload: (fileId, values, callback) => {
            dispatch(getStudentFileDownload(fileId, values, callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getUnreadPreviousUserList: (values, callback) => {
            dispatch(getUnreadPreviousUserList(values, callback));
        },
        getChatMessageHistory: (values, callback) => {
            dispatch(getChatMessageHistory(values, callback));
        },
        clearChatMessages: () => {
            dispatch(clearChatMessages());
        },
        onTyping: (input) => {
            dispatch(onTyping(input));
        },
    };
};

StudentMessageScreen.propTypes = {
    getReferralStudentList: PropTypes.func,
    onCustomSendMessage: PropTypes.func,
};

const ConnectedStudentMessageScreen = withLanguage(
    connect(mapStateToProps, mapDispatchtoProps)(StudentMessageScreen)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedStudentMessageScreen {...props} />
    </LanguageProvider>
);
